import { connectFela } from '../../dependencies';
import MessageContent from './MessageContent';
import * as styles from './MessageContent.styles';

export default connectFela(styles)(MessageContent);
export { MessageContentPropTypes } from './MessageContent';
